__turbopack_context__.v({
  "className": "inter_8baff1d6-module__ibF3qW__className",
  "variable": "inter_8baff1d6-module__ibF3qW__variable",
});
